export function createMarkupAfterTitle(customer, log_in_sub_text, log_out_sub_title, log_out_button_link, log_out_button_title) {
    let container = document.createElement("div");
    container.classList.add("sub-title-container");
  
    let markupAfterTitle = "";
  
    if (customer && log_in_sub_text) {
      markupAfterTitle += `<p>${log_in_sub_text}</p>`;
    } 

    if (!customer && log_out_sub_title) {
      markupAfterTitle += `<p>${log_out_sub_title}</p>`;
    }
    
    if (!customer && log_out_button_link && log_out_button_title) {
      markupAfterTitle += `<a class="button button-primary no-underline mt-2 py-4 px-10 font-sans text-[12px]" href=${log_out_button_link}>${log_out_button_title}</a>`;
    }
    
    container.innerHTML = markupAfterTitle;
    return container;
  }
  
  export function createMarkupBeforeTitle(customer, log_in_eyebrow_text) {
      let container1 = document.createElement("div");
      container1.classList.add("eyebrow-text");
      let markupBeforeTitle = "";
  
      if (customer) {
        if (log_in_eyebrow_text) {
          markupBeforeTitle += `<p class='text-grey-2-a text-center leading-trim tracking-wide uppercase font-suisse-intl font-semibold text-eyebrow-14 mb-[14px] md:text-supergoop-blue'>${log_in_eyebrow_text}</p>`;
        }
      }
  
      container1.innerHTML = markupBeforeTitle;
      return container1;
  }
  
  export function addYellowBackground(yellowTextEl) {
    let text = yellowTextEl.textContent;
  
    if (text && text.includes("[") && text.includes("]")) {
      let oldPointString = text.split("[")[1].split("]")[0];
      let newPointString = `<span class="yellow-text text-yellow-600">${oldPointString}</span>`;
      let finalString = text.replace(`[${oldPointString}]`, newPointString);
  
      yellowTextEl.innerHTML = finalString;
    }
  }
  
  
  function replaceTextInHistoryPopup() {
    let observer = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        for (let node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;
  
          const items = node.querySelectorAll(".row-points-column-wrapper .yotpo-inner-text");
        
          if (window.innerWidth < 1024){
            if (items.length) {
              items.forEach((el) => (el.innerHTML = el.innerHTML.replace("Points", "")));
              observer.disconnect();
            }
          }
        }
      }
    });
  
    return observer;
  }
  
  
  export function copyWidget(yotpoWidget) {
    const widgetInner = yotpoWidget.querySelector(".yotpo-logged-in-view");
  
    const widgetInnerCopy = widgetInner?.cloneNode(true);

  
    widgetInner?.parentNode.insertBefore(widgetInnerCopy, widgetInner);
  
    const OPEN_HISTORY_BTN_SELECTOR = ".yotpo-secondary-button .yotpo-button-style.yotpo-button-standard-size.yotpo-rectangular-btn-type";
  
    const btnCopy = widgetInnerCopy?.querySelector(OPEN_HISTORY_BTN_SELECTOR);
    btnCopy?.classList.add("btn-copy");
  
    const replaceTextObserver = replaceTextInHistoryPopup();
  
    widgetInnerCopy?.querySelector(OPEN_HISTORY_BTN_SELECTOR).addEventListener("click", () => {
      replaceTextObserver.observe(yotpoWidget, { childList: true, subtree: true });
      widgetInnerCopy.style.display = "none";
      yotpoWidget.querySelector(`${OPEN_HISTORY_BTN_SELECTOR}:not(.btn-copy)`).click();
  
      setTimeout(() => {
        const closeBtn = yotpoWidget.querySelector(".yotpo-close-button");
  
        closeBtn.addEventListener(
          "click",
          () => {
            replaceTextObserver.disconnect();
            widgetInnerCopy.style.display = "";
          },
          { once: true }
        );
      }, 800);
    });
  }